import { render, staticRenderFns } from "./AdminMessageCenter.vue?vue&type=template&id=7a17bd9a&scoped=true"
import script from "./AdminMessageCenter.vue?vue&type=script&lang=js"
export * from "./AdminMessageCenter.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageCenter.vue?vue&type=style&index=0&id=7a17bd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17bd9a",
  null
  
)

export default component.exports